import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

type BookingHistorySkeletonProps = {
  isMobile: boolean;
};

export function BookingHistorySkeleton({
  isMobile,
}: BookingHistorySkeletonProps) {
  if (isMobile) {
    return (
      <div className="mt-2 flex flex-col gap-2">
        {[1, 2].map((item) => (
          <div
            key={item}
            className="rounded-2xl bg-card p-5 shadow-xl"
          >
            {/* Booking no. */}
            <div className="flex items-center justify-between">
              <Skeleton className="h-4 w-28" />
              <Skeleton className="h-4 w-20" />
            </div>

            {/* Route */}
            <div className="mt-5">
              <Skeleton className="h-3 w-12" />
              <Skeleton className="mt-2 h-5 w-40" />
            </div>

            {/* Departure / Return */}
            <div className="mt-5 grid grid-cols-2 gap-4">
              <div>
                <Skeleton className="h-3 w-20" />
                <Skeleton className="mt-2 h-4 w-28" />
                <Skeleton className="mt-1 h-3 w-20" />
              </div>

              <div>
                <Skeleton className="h-3 w-16" />
                <Skeleton className="mt-2 h-4 w-28" />
                <Skeleton className="mt-1 h-3 w-20" />
              </div>
            </div>

            {/* Pax / Action */}
            <div className="mt-5 flex items-center justify-between">
              <Skeleton className="h-4 w-20" />
              <Skeleton className="h-9 w-20 rounded-lg" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="mt-2">
      {/* Desktop Header */}
      <div className="grid grid-cols-10 items-center gap-4 rounded-t-[16px] bg-primary px-6 py-3">
        <Skeleton className="h-4 w-24 bg-primary-foreground/20" />

        <Skeleton className="col-span-3 h-4 w-32 bg-primary-foreground/20" />

        <Skeleton className="col-span-2 h-4 w-24 bg-primary-foreground/20" />

        <Skeleton className="col-span-2 h-4 w-24 bg-primary-foreground/20" />

        <Skeleton className="h-4 w-12 bg-primary-foreground/20" />

        <Skeleton className="mx-auto h-4 w-16 bg-primary-foreground/20" />
      </div>

      {/* Desktop Rows */}
      <div className="overflow-hidden rounded-b-2xl bg-card px-6 shadow-xl">
        {[1, 2, 3, 4].map((item) => (
          <div
            key={item}
            className={cn(
              "grid grid-cols-10 items-center gap-4 py-5",
              item > 1 && "border-t border-border",
            )}
          >
            <Skeleton className="h-4 w-28" />

            <Skeleton className="col-span-3 h-4 w-40" />

            <Skeleton className="col-span-2 h-4 w-28" />

            <Skeleton className="col-span-2 h-4 w-28" />

            <Skeleton className="h-4 w-12" />

            <Skeleton className="mx-auto h-9 w-20 rounded-lg" />
          </div>
        ))}
      </div>
    </div>
  );
}